var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconSdk = props => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Layer_2",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18 18"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 2px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Line_Editable_"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "1 5 9 9 17 5 9 1 1 5"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-1",
  points: "1 9 9 13 17 9"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-1",
  points: "1 13 9 17 17 13"
}))))));
export default SvgIconSdk;